import PromotionsDrawerContent from 'containers/Drawers/PromotionsDrawerContent';
import { DrawerReducer, DrawersId, RegisteredDrawerParams } from './interfaces';
import DistributorChange from 'containers/Drawers/DistributorChange';
import PromotionSuggestion from 'containers/Drawers/PromotionSuggestion';
import ImportPromotionDetailDrawerContent from 'containers/Drawers/ImportPromotionDetailDrawerContent';
import React from 'react';
import { FiltersProducts } from 'containers/Drawers/FiltersProducts';
import DistributorChangeCatalog from 'containers/Drawers/DistributorChangeCatalog';
import SideBasketDrawer from 'containers/Drawers/SideBasketDrawer';

export const initialTitles: DrawerReducer['dynamicTitle'] = [
	{
		drawerId: 'distributor-change-drawer',
		title: 0,
	},
];

export const registeredDrawers: Record<DrawersId, RegisteredDrawerParams> = {
	'promotions-drawer': {
		title: 'Promoções com o produto',
		children: <PromotionsDrawerContent />,
		open: false,
		maxWidth: '464px',
		width: '100%',
		padding: '0',
		onCloseProps: {
			'data-component-name': 'back_to_customization',
		},
		onOverlayProps: {
			'data-component-name': 'back_to_customization',
		},
	},
	'import-promotion-details-drawer': {
		title: 'Detalhe da promoção',
		children: React.createElement(ImportPromotionDetailDrawerContent),
		open: false,
		maxWidth: '464px',
		padding: '0',
		showHeader: true,
		index: 2,
		onGoBackProps: {
			'data-component-name': 'back_to_promotion_list',
		},
		onCloseProps: {
			'data-component-name': 'back_to_customization',
		},
		onOverlayProps: {
			'data-component-name': 'back_to_customization',
		},
	},
	'distributor-change-drawer': {
		title: null,
		children: React.createElement(DistributorChange),
		open: false,
		maxWidth: '572px',
		padding: '0',
	},
	'promotion-suggestion': {
		open: false,
		showHeader: false,
		title: 'Detalhe da promoção',
		maxWidth: '464px',
		children: <PromotionSuggestion />,
		padding: '0',
	},
	'side-basket-drawer': {
		open: false,
		title: null,
		maxWidth: '464px',
		side: 'right',
		children: <SideBasketDrawer />,
		padding: '0',
	},
	'filters-products-mobile': {
		title: null,
		children: <FiltersProducts />,
		open: false,
		width: '100%',
		height: '95%',
		borderRadius: '24px 24px 0 0',
		side: 'bottom',
		padding: '0',
	},
	'catalog-distributor-change': {
		title: 'Alterar distribuidores',
		children: React.createElement(DistributorChangeCatalog),
		open: false,
		showHeader: true,
		maxWidth: '464px',
		side: 'right',
		padding: '0',
		index: 1,
	},
};
